import { Config } from 'next-i18n-router/dist/types';

export const i18nConfig: Config = {
    locales: ['en', 'zh'],
    defaultLocale: 'en',
    prefixDefault: false,
};
